import { CarouselProps } from './Carousel';

function populateSlidesOnMouseTouchMove({
  props,
  initialX,
  lastX,
  clientX,
  transformPlaceHolder,
  itemWidth,
  totalItems,
  currentSlide,
}: {
  props: CarouselProps;
  initialX: number;
  lastX: number;
  clientX: number;
  transformPlaceHolder: number;
  itemWidth: number;
  totalItems: number;
  currentSlide: number;
}): {
  direction: string;
  nextPosition: number | undefined;
  canContinue: boolean;
} {
  const { isInfinite } = props;
  let canContinue = false;
  let direction;
  let nextPosition;
  const slidesHavePassedRight = Math.round((initialX - lastX) / itemWidth);
  const slidesHavePassedLeft = Math.round((lastX - initialX) / itemWidth);
  const isMovingRight = initialX > clientX;
  const isMovingLeft = clientX > initialX;
  if (isMovingRight) {
    const isAboutToOverSlide = !(slidesHavePassedRight <= 1);
    if (!isAboutToOverSlide) {
      direction = 'right';
      const translateXLimit = Math.abs(-(itemWidth * (totalItems - 1)));
      const nextTranslate = transformPlaceHolder - (lastX - clientX);
      const isLastSlide = currentSlide === totalItems - 1;
      if (Math.abs(nextTranslate) <= translateXLimit || (isLastSlide && isInfinite)) {
        nextPosition = nextTranslate;
        canContinue = true;
      }
    }
  }
  if (isMovingLeft) {
    const isAboutToOverSlide = !(slidesHavePassedLeft <= 1);
    if (!isAboutToOverSlide) {
      direction = 'left';
      const nextTranslate = transformPlaceHolder + (clientX - lastX);
      const isFirstSlide = currentSlide === 0;
      if (nextTranslate <= 0 || (isFirstSlide && isInfinite)) {
        canContinue = true;
        nextPosition = nextTranslate;
      }
    }
  }
  return {
    direction,
    nextPosition,
    canContinue,
  };
}
function isMouseMoveEvent(e: MouseEvent | TouchEvent): e is MouseEvent {
  return 'clientX' in e && 'clientY' in e;
}
const getCords = ({ clientX, clientY }: { clientX: number; clientY: number }): { clientX: number; clientY: number } => {
  return {
    clientX,
    clientY,
  };
};

export { populateSlidesOnMouseTouchMove, isMouseMoveEvent, getCords };
